import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Immutable from 'immutable';

import {
    resultsConfigSelector,
    describedProductsSelector
} from 'ctm-selectors';

const withSelectedProducts = (Component) => {
    class WithState extends React.PureComponent {

        render() {
            const { selectedProducts, ...rest } = this.props;
            return (
                <Component
                    selectedProducts={selectedProducts}
                    {...rest}
                />
            );
        }

    }

    WithState.propTypes = {
        selectedProducts: PropTypes.instanceOf(Immutable.List)
    };

    return connect(mapStateToProps)(WithState);
};

// @see packages/ctm-components/components/product_compare/product_compare_container.js
const mapStateToProps = (state) => {
    // ['vertical', 'quote', 'results', 'config']
    const resultsConfig = resultsConfigSelector(state);
    const selectedProductIds = resultsConfig.getIn(['helpers', 'filters', 'selectedProductIds']) || Immutable.List();

    const selectedProducts = selectedProductIds.map((selectedProductId) => {
        return describedProductsSelector(state).find((x) => x.getIn(['productMeta', 'id']) === selectedProductId);
    });
    return { selectedProducts };
};

export { withSelectedProducts };
